<template>
    <div>
        <form @submit.prevent="submitForm">
            <div class="form-group">
                <label class="form-label">{{$t('label.title')}}</label>
                <div class="input-group bg-white shadow-inset-2">
                    <div class="input-group-prepend">
                        <span class="input-group-text bg-transparent border-right-0">
                            <i class="fas fa-text"></i>
                        </span>
                    </div>
                    <input type="text" class="form-control bg-transparent pl-3" :placeholder="$t('label.title')" v-model="title" required="">
                </div>
            </div>
            <div class="form-group">
                <label class="form-label">{{$t('label.category')}}</label>
                <div class="input-group">
                    <div class="input-group-prepend w-100">
                        <label class="input-group-text border-right-0">
                            <i class="fas fa-tag"></i>
                        </label>
                        <multiselect 
                            :value="selectedCategory" 
                            :options="categories" 
                            label="text" track-by="id" 
                            :searchable="false" 
                            :show-labels="false" 
                            openDirection="below" 
                            @select="selectCategory">
                        </multiselect>
                    </div>
                </div>
            </div>
            <div class="form-group mt-3">
                <div class="custom-control custom-switch">
                    <input type="checkbox" class="custom-control-input" id="subItemEnable" v-model="enable">
                    <label class="custom-control-label" for="subItemEnable">{{$t('label.enable')}}</label>
                </div>
            </div>
            <div class="text-left border-top pt-3 mt-3 mb-3">
                <div class="row">
                    <div class="col-6">
                        <button v-if="!isEdit" type="button" class="btn border-0 btn-secondary btn-padding waves-effect waves-themed mr-3" @click="returnSubItemList()">{{$t('button_link.cancel')}}</button>
                        <button type="submit" class="btn border-0 btn-primary btn-padding waves-effect waves-themed">{{$t('button_link.save')}}</button>
                    </div>
                    <div class="d-none col-6 text-right">
                        <button v-if="isEdit" type="button" class="btn border-0 btn-danger btn-padding waves-effect waves-themed" @click="deleteSubCategory">Delete</button>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>
<script>
import {getCategoryText} from './../../../../assets/js/dashboard/dashboard'
export default {
    name: 'itemSubForm',
    props:{
       isEdit: { type: Boolean },
       category: { type: Array },
    },
    data(){
        return{
            type: "discount",
            categories: [],
            folderID: 0, title: "", selectedCategory: {}, enable: true
        }
    },
    methods:{
        setCategoryOptions(){
            this.categories = this.category.slice(1, this.category.length)
            this.selectedCategory = this.categories[0]
        },
        selectCategory(item){
            this.selectedCategory = item
        },
        returnSubItemList(){
           this.$emit('returnSubItemList')
        },
        editItemSubForm(item){
            this.setCategoryOptions();
            this.folderID = item.folderID;
            this.title = item.title;
            this.selectedCategory = {id: item.category, text: getCategoryText(item.category, this.category)};
            this.enable = item.isEnable == 1 ? true : false;
        },
        submitForm(){
            var data = {
                title: this.title,
                category: this.selectedCategory.id,
                type: this.type,
                isEnable: this.enable ? 1 : 0
            }
            this.$emit('submitForm', data);
        },
        deleteSubCategory(){
            this.$emit('deleteSubCategory', this.folderID, this.title)
        }
    },
    mounted(){
        let $vm = this;
        $vm.setCategoryOptions();
    }
}
</script>